import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { AngularFirestore } from "@angular/fire/firestore";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { LanguageDraft } from "src/app/Models/language-models.interface";
import { Question } from "src/app/Models/question.interface";
import { LessonManagerService } from "src/app/Services/LessonManager/lesson-manager.service";
import { UserManager } from "src/app/Services/UserManager/user-manager";

@Component({
  selector: "app-lesson-editor",
  templateUrl: "./lesson-editor.component.html",
  styleUrls: ["./lesson-editor.component.css"],
})
export class LessonEditorComponent implements OnInit {
  lang: string;
  config: LanguageDraft;
  lessonId: number;
  cards;
  selectedLesson;
  selectedQuestion;
  questions;
  preview = false;
  leaving = new Subject();
  constructor(
    private afs: AngularFirestore,
    private route: ActivatedRoute,
    private lm: LessonManagerService,
    private um: UserManager,
    private location: Location,
    private router: Router
  ) {
    this.lang = this.route.snapshot.paramMap.get("id") ?? "en";
    const incomingCard = this.route.snapshot.paramMap.get("lessonId") ?? null;
    this.selectedLesson = this.lm.getCard(+incomingCard);
    this.selectedQuestion = 1;
    this.cards = this.lm.getLessonCards();
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.um
      .getProfileSubject()
      .subscribe((profile) => profile && this.getLatestDraft());
  }

  getLatestDraft() {
    this.afs
      .collection("Languages")
      .doc(this.lang)
      .collection("Drafts", (ref) => ref.orderBy("version", "desc"))
      .valueChanges()
      .takeUntil(this.leaving)
      .subscribe((data) => {
        console.log(data);
        this.config = data[0] as LanguageDraft;
        console.log("update config", this.config);
        this.getLessonContents(this.config.version);
      });
  }

  getLessonContents = (version: number) => {
    console.log("selected card = ", this.selectedLesson);
    this.afs
      .collection("Languages")
      .doc(this.lang)
      .collection("Drafts")
      .doc(String(version))
      .collection("Lessons")
      .doc(String(this.selectedLesson.id))
      .valueChanges()
      .takeUntil(this.leaving)
      .subscribe((data) => {
        this.questions = Object.values(data).sort(
          (a: Question, b: Question) => +a.questionID - +b.questionID
        );
        console.log("lesson data", this.questions);
      });
  };

  ngOnDestroy() {
    this.leaving.next();
  }

  dontPropagate = (event) => {
    event && event.stopPropagation();
  };

  toggleLessonCompletion = (event, card) => {
    this.afs
      .collection("Languages")
      .doc(this.lang)
      .collection("Drafts")
      .doc(String(this.config!.version))
      .update({
        completed: {
          ...this.config.completed,
          [card.id]: event.checked,
        },
      });
  };

  setSelectedCard = (card) => {
    this.leaving.next();
    this.selectedLesson = card;
    this.getLessonContents(this.config.version);
  };
  deselectLesson = () => {
    this.selectedLesson = null;
  };

  togglePreview = () => {
    this.preview = !this.preview;
  };

  previousQuestion = () => {
    if (this.selectedQuestion > 1) {
      this.selectedQuestion--;
    }
  };

  nextQuestion = () => {
    if (this.selectedQuestion < this.questions.length) {
      this.selectedQuestion++;
    }
  };
}
